import { useEffect, useRef } from "react";

export default function ContextMenu({ x, y, items, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!ref.current?.contains(e.target)) onClose();
    };
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("mousedown", onDocClick);
    window.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  const clampedX = Math.min(x, window.innerWidth - 200);
  const clampedY = Math.min(y, window.innerHeight - items.length * 36 - 16);

  return (
    <ul
      ref={ref}
      className="context-menu"
      style={{ left: Math.max(4, clampedX), top: Math.max(4, clampedY) }}
    >
      {items.map((item, i) =>
        item.separator ? (
          <li key={i} className="context-menu-sep" />
        ) : (
          <li
            key={i}
            className={item.danger ? "danger" : ""}
            onClick={() => {
              onClose();
              item.onClick();
            }}
          >
            {item.label}
          </li>
        )
      )}
    </ul>
  );
}
